module.exports = __webpack_public_path__ + "static/ufrn-1105af4c497d240980ffc5f65c728f1b.png";